import React, { useEffect, useState } from 'react'
import "./ArticleContent.css"
import { useNavigate, useParams } from 'react-router-dom';
import articles from '../../ArticlesData';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';
import { Helmet } from 'react-helmet';

function ArticleContent() {
  const { id } = useParams();
  const [blogData,setBlogData] = useState()
  const navigate = useNavigate()
  const [apiBlogsData, setApiBlogsData] = useState();
  const [loading, setLoading] = useState(true);

  
  let allBlogsCalled = false;

   const getAllBlogs = async () => {
    if (allBlogsCalled) return;
    allBlogsCalled = true;

    setLoading(true);
    axios
      .get(`/blogs`, {})
      .then((res) => {
        if (res.data.status === "success") {
          let Updated_recent_blogs = [];
          let blog = res.data.data.find((item) => item.slug_url == id);
          res.data.data.forEach((item) => {
            Updated_recent_blogs.push({
              id: item.blog_id,
              slug_url: item.slug_url,
              blog_creative: item.blog_image,
              date: item.published_date,
              contentFileAr:item.blogs_content,
              main_heading:item.title,
              paragraph:item.brief_paragraph,
            });
          });
          setApiBlogsData([...articles,...Updated_recent_blogs]);
          let currentblog = [...articles,...Updated_recent_blogs].find((item) => item.slug_url == id);
          setBlogData(currentblog);



          setLoading(false)

          
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err");
        setApiBlogsData(null)
        setLoading(false);
      });


    // Frontend only blog 
    //  let currentblog = [...articles].find((item) => item.slug_url == id);
    //       setBlogData(currentblog);
    //       setLoading(false)
   
  };
  
  useEffect(()=>{
    getAllBlogs()
  },[id])

  
  const convertToSlug = (str) => {
    return str.toLowerCase().replace(/\s+/g, "-");
  };

  const redirectUserToBlog = (id) => {
    if (!id) return;
    let slug = convertToSlug(id);
    navigate(`/article/${slug}`);

  };
  return (
    <>
    {
      blogData?.blog_creative &&
       <div className={`${blogData?.fullWidth?"d-none":""} container py-5`} >
                      <div
                          style={{
                              backgroundImage:`url("${blogData?.blog_creative}")`,
                              backgroundRepeat:"no-repeat",
                              backgroundSize:"cover",
                              backgroundPosition:"top left",
                              width:"100%",
                              height:"500px",
                              minHeight:"60vh",
                              borderRadius:"20px",
                          }}
                          className='mx-auto'
                      >
      
                      </div>
              </div>
    }
        <div className={`${blogData?.fullWidth?"pt-5":""} ArticleContent-container'`}>
            <div className='container'>
                <div className='text-content'>
                    {!blogData?.fullWidth && <h3 className='main-heading'>{blogData?.main_heading}</h3>}
                    <div className='row mt-4'> 
                      <div className={`${blogData?.fullWidth ? "col-lg-12":"col-lg-8"}`}>
                        {
                          blogData ?
                          <>
                          <Helmet>
                            {blogData?.metaTitle && <title>{blogData.metaTitle}</title>}
                            {blogData?.metaDescription && <meta name='description' content={blogData.metaDescription} />}
                            {blogData?.canonicalLink && <link rel="canonical" href={blogData.canonicalLink}></link>}
                          </Helmet>
                          <>
                            {
                              blogData?.contentFileAr?
                                  <>
                                    <div className={`para_main pt-0 pb-2 `} style={{color:"black"}} dangerouslySetInnerHTML={{ __html: blogData?.paragraph }}></div>
                                    {blogData?.contentFileAr.map((item) => (
                                      <>
                                        <h2 className="h2_main pb-2 body-heading" style={{color:"black",textTransform:"capatalize"}}>{item.heading}</h2>
                                        <div className={`para_main pb-5 body-paragraph `} dangerouslySetInnerHTML={{ __html: item.paragraph }}></div>
                                      </>
                                    ))}
                                  </>
                              :
                              <div className='blog-content-container' dangerouslySetInnerHTML={{__html:blogData?.contentFile}}>

                              </div>
                            }
                          </>
                          </>
                          :
                          <Spinner/>
                        }

                      </div>
                      <div className='col-lg-1'>
                        <div className='line-seprator mx-auto'>

                        </div>

                      </div>
                      <div className={`${blogData?.fullWidth ?"d-none":"col-lg-3"}`}>
                        <h5 className='sub-heading mb-3'>Staff Pick</h5>
                        {
                          articles.slice(0,3).map((ele)=>{
                            return(
                              <div className='blog-card mb-4' onClick={()=>{redirectUserToBlog(ele?.slug_url)}}>
                                <img src={ele?.blog_creative} className='img-fluid' style={{borderRadius:"20px"}} alt='blog thumbnail' />

                                  <p className='body-paragraph mt-2' style={{fontSize:"1rem"}}>{ele?.main_heading}</p>
                              </div>
                            )
                          })
                        }
                        {/* <div className='blog-card mb-4'>
                          <img src='/images/creatives/slider-img-1.png' className='img-fluid' style={{borderRadius:"20px"}} />

                            <p className='body-paragraph mt-2' style={{fontSize:"1.3rem"}}>How to spot early sign ...</p>

                        </div>
                        <div className='blog-card mb-4'>
                          <img src='/images/creatives/slider-img-2.png' className='img-fluid' style={{borderRadius:"20px"}} />

                            <p className='body-paragraph mt-2' style={{fontSize:"1.3rem"}}>How to spot early sign ...</p>

                        </div>
                        <div className='blog-card mb-4'>
                          <img src='/images/creatives/slider-img-3.png' className='img-fluid' style={{borderRadius:"20px"}} />

                            <p className='body-paragraph mt-2' style={{fontSize:"1.3rem"}}>How to spot early sign ...</p>

                        </div> */}
                      </div>    

                    </div>
                </div>

            </div>
        </div>
    </>
  )
}

export default ArticleContent